const COMMON_COLORS = {
    error_60: '#D92020',
    purple_10: '#F6F2FF',
    purple_30: '#D4BBFF',
    purple_40: '#BE95FF',
    primary_10: '#EDF5FF',
    primary_20: '#DDE9FF',
    primary_50: '#3A85FF',
    primary_60: '#3481FF',
    primary_70: '#0046E2',
    primary_80: '#0132b0',
    warning_10: '#FFF1E5',
    warning_40: '#FF8D64',
    warning_50: '#FF5C22',
    attention_10: '#FEF5D7',
    cyan_10: '#E5F6FF',
    cyan_50: '#1192E8',
    success_10: '#EAFCF1',
    success_50: '#1BA049',
};

const ELEMENT_COLORS = {
    light_primary: '#9CA0A7',
};

const SPECIAL_COLORS = {
    newBg: '#F9F9FA',
    grey: '#E5E7EB',
    bright_blue: '#0062ff',
};

const NEUTRAL_COLORS = {
    neutral_00: '#FFFFFF',
    neutral_05: '#F3F4F6',
    black: '#000000',
    blue: '#689FFF',
    neutral_10: '#E5E7EB',
    neutral_20: '#D6D8DD',
    neutral_30: '#B1B5BB',
    neutral_50: '#74777F',
    neutral_70: '#505258',
    neutral_80: '#37383C',
    neutral_90: '#22242A',
};

export const COLORS = {
    inherit: 'inherit',
    ...SPECIAL_COLORS,
    ...NEUTRAL_COLORS,
    ...COMMON_COLORS,
    ...ELEMENT_COLORS,
};

export const hexToRGB = (hex: string, alpha: string | number) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
        return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    } else {
        return 'rgb(' + r + ', ' + g + ', ' + b + ')';
    }
};
